let hosts = {
    'mozart.pytech.ai':  'https://mozart-api.pytech.ai',
    'mozart-staging.pytech.ai':  'https://mozart-staging-api.pytech.ai',
    'localhost:8080':  'http://127.0.0.1:8000',
    'localhost':  'http://127.0.0.1',
};
export const config = {
    apiUrl: hosts[window.location.host]
};